import styled from 'styled-components'
import { rgba } from 'polished'
import { color, spacing, typography, Media, transition } from '../../style'

export const UnderLine = styled.span`
  content: '';
  display: block;
  height: 4px;
  width: 160px;
  background: ${color.gradient};
`

export const SolutionCard = styled.div`
  width: 520px;
  height: 460px;
  background-color: ${color.panel};
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${spacing.large};
  margin: auto;
  h3 {
    color: white;
    font-size: ${typography.h3};
  }
  svg {
    font-size: 200px;
  }
  p {
    margin: 0;
  }
  ${Media.lessThan(Media.small)} {
    width: auto;
    height: auto;
    font-size: ${typography.textSmall};
    padding: ${spacing.base};
    margin: ${spacing.small} 0;
    svg {
      font-size: 100px;
    }
    h3 {
      font-size: ${typography.h4};
    }
  }
`
export const OddsCard = styled.div`
  width: 290px;
  height: 380px;
  text-align: center;
  overflow: hidden;
  padding: 0 ${spacing.small};
  margin: auto;
  font-size: ${typography.textSmall};
  p {
    margin: 0;
  }
  h3 {
    color: white;
    margin: 0;
    line-height: 2;
    font-size: ${typography.h3};
    transition: ${transition('color')};
  }
  transition: ${transition('background-color')};
  :hover {
    h3 {
      color: ${color.primary};
    }
    background-color: ${rgba(color.panel, 0.5)};
  }
  ${Media.lessThan(Media.small)} {
    width: auto;
    height: auto;
    font-size: ${typography.textSmall};
    padding: 0;
    margin: ${spacing.small} 0;
    h3 {
      font-size: ${typography.text};
    }
  }
`
export const OddsIconWrap = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin: 40px auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${color.textDark};
  svg {
    font-size: 70px;
  }
  ${Media.lessThan(Media.small)} {
    width: 85px;
    height: 85px;
    svg {
      font-size: 50px;
    }
  }
`
export const Background = styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`
export const PartnerCard = styled.div`
  width: 280px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  transition: ${transition('background-color')};
  ${Media.lessThan(Media.small)} {
    width: auto;
    height: 80px;
  }
  img {
    max-width: 80%;
    max-height: 70%;
  }
  :hover {
    background-color: ${color.panel};
  }
`
